import { Button, Modal } from "react-bootstrap"
import { IoClose, IoBook, IoVolumeHigh } from "react-icons/io5"

const BookLanguageModal = (props) => {
  const { updateShowLangOption, navigateToBook, selectedBook } = props
  return (
    <div className="language-modal">
      <Modal show={true} onHide={() => updateShowLangOption()} backdrop="static" keyboard={false} animation={false} size="xl" centered className="custom-book-modal">
        <Modal.Body className="lang-modal-body p-0">
          <button className="book-modal-close-btn" onClick={() => updateShowLangOption()}>
            <IoClose />
          </button>
          <div className="book-modal-container">
            <div className="book-modal-left">
              <img src={selectedBook?.book_cover_image} alt={selectedBook?.title} className="book-modal-cover-img" />
              <div className="book-spine"></div>
            </div>
            <div className="book-modal-right">
              <h2 className="book-modal-title">{selectedBook?.title}</h2>
              <p className="book-modal-description">{selectedBook?.description}</p>

              <div className="book-modal-languages-section">
                <h4 className="languages-hd">Select Language</h4>
                <div className="all-btns-wrap justify-content-start">
                  {[
                    { name: "English", allowed: true },
                    { name: "Urdu", allowed: true },
                    { name: "Spanish", allowed: false },
                    { name: "German", allowed: false },
                    { name: "Hindi", allowed: false },
                    { name: "Arabic", allowed: false }
                  ].map((lang) => {
                    const isAllowed = lang.allowed;
                    return (
                      <Button
                        key={lang.name}
                        className={`all-btns ${!isAllowed ? 'disabled-lang' : 'active-lang'}`}
                        variant="warning"
                        disabled={!isAllowed}
                        onClick={() => isAllowed && navigateToBook(lang.name.toLowerCase())}
                      >
                        <div className="lang-btn-content">
                          <span className="lang-name">{lang.name}</span>
                          {isAllowed && (
                            <div className="lang-icons-wrap">
                              <IoBook title="Reading Available" />
                              <IoVolumeHigh title="Listening Available" />
                            </div>
                          )}
                          {!isAllowed && (
                            <span className="coming-soon-tag">Coming Soon</span>
                          )}
                        </div>
                      </Button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div >
  )
}

export default BookLanguageModal
